import { Actions } from '../enums/ActionEnums';
import { ActionType } from '../models/appContext';
import { RecipientListType } from '../models/recipientList';

export const recipientListReducer = (
  state: RecipientListType | null,
  action: ActionType
): RecipientListType | null => {
  switch (action.type) {
    case Actions.SetRecipientList:
      const { recipientList } = action.payload;
      return {
        id: recipientList?.id,
        contactTitleIds: recipientList?.contactTitleIds || [],
        companyTypeIds: recipientList?.companyTypeIds || [],
        name: recipientList?.name,
        membershipTypeIds: recipientList?.membershipTypeIds || [],
        interestIds: recipientList?.interestIds || [],
        countryIds: recipientList?.countryIds || [],
        excludedContactIds: recipientList?.excludedContactIds || [],
        includedContactIds: recipientList?.includedContactIds || []
      };
    case Actions.SetRecipientListContactTitles:
      const { contactTitleIds } = action.payload;
      return {
        ...(state as RecipientListType),
        contactTitleIds
      };
    case Actions.SetRecipientListCompanyTypes:
      const { companyTypeIds } = action.payload;
      return {
        ...(state as RecipientListType),
        companyTypeIds
      };
    case Actions.SetRecipientListName:
      const { name } = action.payload;
      return {
        ...(state as RecipientListType),
        name
      };
    case Actions.SetRecipientListMemberships:
      const { membershipTypeIds } = action.payload;
      return {
        ...(state as RecipientListType),
        membershipTypeIds
      };
    case Actions.SetRecipientListInterests:
      const { interestIds } = action.payload;
      return {
        ...(state as RecipientListType),
        interestIds
      };
    case Actions.SetRecipientListCountries:
      const { countryIds } = action.payload;
      return {
        ...(state as RecipientListType),
        countryIds
      };
    case Actions.SetRecipientListExcludedContacts:
      const { excludedContactIds } = action.payload;
      return {
        ...(state as RecipientListType),
        excludedContactIds
      };
    case Actions.RecipientListIncludeContact:
      const { contactId } = action.payload;
      return {
        ...(state as RecipientListType),
        includedContactIds: [contactId, ...(state?.includedContactIds as number[])]
      };
    case Actions.RecipientListRemoveIncludedContact:
      return {
        ...(state as RecipientListType),
        includedContactIds: (state?.includedContactIds as number[]).filter(
          (c) => c !== action.payload.contactId
        )
      };
    case Actions.ResetRecipientList:
      return null;
    default:
      return state;
  }
};
